<template>
  <div>
    <v-card class="vms-surface" elevation="0">
      <div v-if="loading">
        <v-toolbar flat class="px-4 pt-4">
          <div align="left">
            <v-toolbar-title class="vms-page-title">
              <v-icon class="mr-2 mt-n1" color="info">mdi-view-dashboard</v-icon>
              Dashboard
            </v-toolbar-title>
          </div>
        </v-toolbar>

        <v-progress-linear indeterminate color="info"></v-progress-linear>

        <v-divider></v-divider>
        <v-sheet height="450" max-width="100%"></v-sheet>
      </div>

      <div v-else class="pa-4">
        <v-alert
          v-if="showRoleHint"
          dense
          text
          type="info"
          class="mb-4"
          border="left"
          dismissible
          @input="onRoleHintDismiss"
        >
          {{ roleHint }}
          <v-btn text small color="info" class="text-capitalize ml-2" :to="roleHintRoute">Go</v-btn>
          <v-btn text small class="text-capitalize" to="/help">Help</v-btn>
        </v-alert>

        <SummaryDashboard v-if="facility_manager"></SummaryDashboard>
        <Event v-else-if="!facility_manager"></Event>
        <FacilityMap v-else v-bind:facilities="user_managed_facilities"></FacilityMap>
      </div>
    </v-card>
  </div>
</template>

<script>
import FacilityService from '../../services/facilities.service';
import Event from './Event.vue';
import FacilityMap from './FacilityMap.vue';
import SummaryDashboard from './SummaryDashboard.vue';

export default {
  components: {
    Event, 
    FacilityMap,
    SummaryDashboard
  },
  name: "Dashboard",
  data() {
    return {
      loading: true,
      facility_manager: false,
      user_managed_facilities: [],
      showFacilityMap: false,
      roleHintVisible: true,
    }
  },
  computed: {
    org() {
      return JSON.parse(localStorage.getItem("org"));
    },
    showEventsCalendar() {
      if (this.org) {
        return false;
      } else {
        return true;
      }
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    isAdmin() {
      const v = this.user?.is_admin;
      return v === true || v === 1 || v === '1';
    },
    isSecurity() {
      const roles = this.user?.user_roles || this.user?.roles || [];
      return roles.some((r) => {
        const title = (r.roles?.title || r.title || r.slug || '').toLowerCase();
        return title.includes('watchman') || title.includes('security');
      });
    },
    roleHint() {
      if (this.isAdmin) {
        return 'Admin tip: finish the VMS setup checklist (workflows, branch groups, mail/SMS), then invite or approve visits.';
      }
      if (this.isSecurity) {
        return 'Security tip: use the Android sign-in app for check-in/out. View schedules under Watchmen Schedule.';
      }
      // Hosts already land on Schedule Visit in-org — no dashboard tip for general users.
      return null;
    },
    roleHintRoute() {
      if (this.isAdmin) return '/workflows';
      if (this.isSecurity) return '/watchmen-schedule';
      return '/organisations';
    },
    showRoleHint() {
      return !!this.roleHint
        && this.roleHintVisible
        && localStorage.getItem('vms_role_hint_dismissed') !== '1';
    },
  },
  created() {
    this.$nextTick(() => {
      setTimeout(this.userManagedFacilities, 1500);
    });
  },
  methods: {
    onRoleHintDismiss(visible) {
      if (visible === false) {
        localStorage.setItem('vms_role_hint_dismissed', '1');
        this.roleHintVisible = false;
      }
    },
    userManagedFacilities() {
      FacilityService.managerFacilities(localStorage.getItem('token')).then(
        success => {
          if (success.status === 200) {
            if ((success.data.data).length > 0 && this.user.is_admin == true) {
              this.user_managed_facilities = success.data.data;
              this.facility_manager = true;
              this.loading = false;
            }
          }

          this.loading = false;
        },
        (error) => {
          if (error.response.status === 401) {
            this.handleLogout();
          }
        }
      );
    },
    handleLogout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  }
}
</script>
